export default __webpack_public_path__ + "static/media/visible.e8035430.svg";